import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Box, styled, Typography } from '@mui/material';
import { Fragment } from 'react';

const calculateSize = (mobile: boolean, variant: 'default' | 'mini' | 'drawer') => {
	if (variant === 'mini') {
		return '81px';
	}
	if (variant === 'drawer') {
		return '84px';
	}
	if (mobile) {
		return '120px';
	}
	return '160px';
};

export const StyledBox = styled<any>(Box)(({ mobile, variant }) => ({
	width: calculateSize(mobile, variant),
	height: calculateSize(mobile, variant),
	minWidth: calculateSize(mobile, variant),
	position: 'relative',
	margin: 0,
	padding: 0,
}));

export const StyledImg = styled<any>(Img)(({ mobile, exhausted, variant }) => ({
	width: calculateSize(mobile, variant),
	height: calculateSize(mobile, variant),
	opacity: exhausted ? 0.6 : 1,
}));

export const StyledCoverImg = styled<any>(Box)(({ mobile, variant }) => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: calculateSize(mobile, variant),
	height: calculateSize(mobile, variant),
	margin: 0,
	padding: 0,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-end',
}));

export const StyledCoverText = styled<any>(Typography)(({ variant }) => ({
	backgroundColor: '#000000',
	opacity: 0.6,
	color: '#FFFFFF',
	textAlign: 'center',
	margin: 0,
	padding: 0,
	fontSize: variant === 'mini' ? '10px' : '13px',
	paddingTop: variant === 'mini' ? '2px' : '4px',
	paddingBottom: variant === 'mini' ? '2px' : '4px',
	width: '100%',
	height: 'fit-content',
}));

interface ProductImgProps {
	fullImageRaw: string;
	alt: string;
	href?: string;
	mobile?: boolean;
	exhausted?: boolean;
	expiration?: boolean;
	variant?: 'default' | 'mini' | 'drawer';
}

export const ProductImg: React.FC<ProductImgProps> = ({
	fullImageRaw,
	href,
	alt,
	mobile,
	exhausted,
	expiration,
	variant,
}) => (
	<RenderProductImg
		fullImageRaw={fullImageRaw}
		render={(src) => (
			<StyledBox mobile={mobile} variant={variant}>
				<Linkable href={href}>
					<StyledImg mobile={mobile} exhausted={exhausted} variant={variant} src={src} alt={alt} />
					{exhausted || expiration ? (
						<StyledCoverImg mobile={mobile} variant={variant}>
							<StyledCoverText mobile={mobile} variant={variant}>
								{exhausted ? 'Agotado' : 'Caducado'}
							</StyledCoverText>
						</StyledCoverImg>
					) : (
						<Fragment>{}</Fragment>
					)}
				</Linkable>
			</StyledBox>
		)}
	/>
);
